package com.imobly.imobly.api.dto

import com.imobly.imobly.domain.Tenant
import kotlinx.serialization.Serializable

@Serializable
data class PaginatedTenant(
    val tenants: List<Tenant> = emptyList(),
    val totalPages: Int = 0
)
